import ApiService from '@/services/core/api.service'

const AreaService = {
  async get (query) {
    return ApiService.get(`marketing-officer/areas?${query}`)
  },

  async post (payload) {
    return ApiService.post('marketing-officer/areas', payload)
  },

  async put (payload) {
    return ApiService.put(`marketing-officer/areas/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`marketing-officer/areas/${payload.id}`)
  }
}

export default AreaService
